import { broadcastAllInspections } from 'serviceWorker/broadcasts/inspections';
import * as inspections from 'serviceWorker/db/inspections/inspections';
import * as inspectionsService from 'serviceWorker/db/inspections/inspectionsService';
import { getOne as getPermissionOnProject } from 'serviceWorker/db/permissions';

import { Services } from 'shared/domain/messages/message';
import { UserRole } from 'shared/types/userRole';
import { get as getSelectedProject } from 'serviceWorker/db/selectedProject';
import {
  fetchInspections,
  fetchUpdatedInspections,
} from './fetchInspections';

import { inspectionContract } from 'shared/domain/inspection/inspectionContract';
import { createSyncedEntity } from '../factories/createSyncedEntity';

/**
 * Download and sync of the inspections; the source's `sync` is its entry point.
 */
export const inspectionsSync = createSyncedEntity({
  entityName: Services.INSPECTIONS,
  contract: inspectionContract,
  repository: inspections,
  service: inspectionsService,
  fetch: fetchInspections,
  fetchUpdated: fetchUpdatedInspections,
  publishCollection: broadcastAllInspections,
  canSynchronize: canSyncInspections,
});


/** Standard users have no access to inspections: nothing is downloaded for them. */
export async function canSyncInspections(): Promise<boolean> {
  const selectedProject = await getSelectedProject();
  if (!selectedProject) {
    return false;
  }
  const currentProjectPermissions = await getPermissionOnProject(
    selectedProject._id
  );
  if (!currentProjectPermissions) {
    return false;
  }

  return currentProjectPermissions.role !== UserRole.standard;
}
